module.exports = __webpack_public_path__ + "static/media/terrase.ab5e2698.jpg";